import apiClient from '../lib/apiClient';

const metaAdsService = {
  getStatus() {
    return apiClient.request('/meta/status');
  },

  getConnectUrl() {
    return apiClient.request('/meta/connect');
  },

  disconnect() {
    return apiClient.request('/meta/disconnect', { method: 'POST' });
  },

  launchCampaign(payload) {
    return apiClient.request('/meta/launch-campaign', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },

  getPerformance(campaignId) {
    return apiClient.request(`/meta/performance?campaign_id=${encodeURIComponent(campaignId)}`);
  },

  getCampaigns() {
    return apiClient.request('/meta/campaigns');
  }
};

export default metaAdsService;
